/**
 * Schema of EmailAuditoria
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import EmailAuditoriaNivel from '@/model/resource/EmailAuditoriaNivel'

export default (model: EmailAuditoriaNivel): Schema => ({
  idEmailAuditoriaFk: {
    content: model.idEmailAuditoriaFk,
    editable: false,
  },

  email: {
    content: model.email,
    input: InputType.EMAIL,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  idEmailNivelFk: {
    content: model.emailNivel ? model.emailNivel.idEmailNivelPk : 0,
  },

   idEmailAuditoriaNivelPk: {
       content: model.idEmailAuditoriaNivelPk ? model.idEmailAuditoriaNivelPk : 0,
   },

  ativo: {
    content: bool(model.ativo),
    input: InputType.CHECKBOX,
  },
})
